import React from "react";

const deals = [
  {
    city: "London",
    date: "Oct 07 - Oct 14",
    price: "$855.61",
    image: "/assets/london.jpg",
  },
  {
    city: "Dallas",
    date: "Jun 20 - Oct 18",
    price: "$3371.71",
    image: "/assets/dallas.jpg",
  },
  {
    city: "Barcelona",
    date: "Aug 08 - Aug 28",
    price: "$605.81",
    image: "/assets/barc.jpg",
  },
  {
    city: "Boston",
    date: "Jul 08 - Oct 07",
    price: "$1309.11",
    image: "/assets/boston.jpg",
  },
  {
    city: "Chicago",
    date: "Jun 17 - Jun 24",
    price: "$244.97",
    image: "/assets/chicago.jpg",
  },
  {
    city: "Budapest",
    date: "Jun 24 - Jul 23",
    price: "$1300.41",
    image: "/assets/budapest.jpg",
  },
];

const DealsSection = () => {
  return (
    <section className="py-16 px-6 bg-gradient-to-br from-[#E8F9F6] via-[#F5FCFB] to-white">
      
      {/* TITLE */}
      <div className="text-center mb-12">
        <h2 className="text-3xl font-extrabold text-gray-900">
          Explore Top <span className="text-teal-600">Flight Deals</span>
        </h2>
        <p className="text-gray-600 mt-3 max-w-xl mx-auto">
          Discover curated airfares to top destinations — premium value, modern
          travel experience, powered by BookTrip4Me.
        </p>
      </div>

      {/* DEAL GRID */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {deals.map((deal, index) => (
          <div
            key={index}
            className="relative rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.03] bg-white"
          >
            <img
              src={deal.image}
              alt={deal.city}
              className="w-full h-56 object-cover"
            />

            {/* OVERLAY */}
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/60 via-black/0 to-transparent text-white">
              <h3 className="text-lg font-semibold">{deal.city}</h3>
              <div className="flex justify-between text-sm mt-1">
                <span>{deal.date}</span>
                <span>
                  From{" "}
                  <span className="font-bold text-teal-300">
                    {deal.price}
                  </span>
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
};

export default DealsSection;
